import { render, staticRenderFns } from "./InstitucionesExternas.vue?vue&type=template&id=848e8e4a&scoped=true"
import script from "./InstitucionesExternas.vue?vue&type=script&lang=js"
export * from "./InstitucionesExternas.vue?vue&type=script&lang=js"
import style0 from "./InstitucionesExternas.vue?vue&type=style&index=0&id=848e8e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848e8e4a",
  null
  
)

export default component.exports